import React, { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Pagination, message } from 'antd'
import useTitle from '../../../../hooks/useTitle'
import styles from './index.module.scss'
import request from '../../../../network/request'
import OrderItem from '../components/OrderItem'
import Skeleton from '../components/Skeleton'
import { Placeholder } from '../components/Placeholder'
import OrderType from '../components/OrderType'
import useOrderListQuery from '../store/useOrderListQuery'
import useOrderSearchQuery from '../store/useOrderSearchQuery'
import useOrderType from '../store/useOrderType'
import { MS_LIST_TABS } from '../../../../config/index'

const PAGE_SIZE = 5

export default function OrderDetail() {
  useTitle('移动服务单管理')

  const { orderListQuery, updatePage, updateTab } = useOrderListQuery()
  const { resetOrderSearchQuery } = useOrderSearchQuery()
  const { orderType } = useOrderType()

  const history = useHistory()
  const curTabRef = useRef(orderListQuery.curTab)
  const pageIndexRef = useRef(orderListQuery.pageIndex)

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isError, setIsError] = useState<boolean>(false)
  const [orderList, setOrderList] = useState<any[]>([])
  const [total, setTotal] = useState(0)

  useEffect(() => {
    getInitialData()

    return () => {
      message.destroy()
    }
  }, [orderType.default])

  const getInitialData = () => {
    setIsLoading(true)
    pageIndexRef.current = 1
    getOrderList()
  }

  const handleChangeTab = (tabValue: string) => {
    curTabRef.current = tabValue
    pageIndexRef.current = 1

    updateTab(tabValue)

    getOrderList()
  }

  const handleChangePage = (page: number) => {
    pageIndexRef.current = page

    updatePage(page)

    getOrderList()
  }

  const getOrderList = async () => {
    const loaded = message.loading('加载中...', 0)
    try {
      const { total, records }: any = await request.get(
        '/dragon/service/order/listPage',
        {
          params: {
            orderStatisticsType: curTabRef.current,
            pageSize: PAGE_SIZE,
            pageIndex: pageIndexRef.current,
            orderType: orderType.default,
          },
        }
      )
      setTotal(total)
      setOrderList(records)
      setIsError(false)
    } catch (err) {
      setIsError(true)
    } finally {
      loaded()
      setIsLoading(false)
    }
  }

  const handleRefresh = () => {
    getOrderList()
  }

  const handleLinkToSearch = () => {
    resetOrderSearchQuery()
    history.push('/ms/search')
  }
  const Reload = () => {
    return (
      <div className={styles.retryWrap} onClick={getInitialData}>
        重试
      </div>
    )
  }

  return (
    <div className={styles.pageList}>
      <div className={styles.headerWrap}>
        <div className={styles.searchWrap} onClick={handleLinkToSearch}>
          <div className={styles.searchLink}>
            <div className={styles.searchIcon}></div>
            <p>搜索</p>
          </div>
        </div>
        <div className={styles.tapContainer}>
          {MS_LIST_TABS.map((item) => {
            return (
              <div
                key={item.value}
                className={[
                  styles.tabItem,
                  curTabRef.current === item.value ? styles.active : '',
                ].join(' ')}
                onClick={() => handleChangeTab(item.value)}
              >
                {item.label}
              </div>
            )
          })}
        </div>
      </div>
      {isLoading ? (
        <Skeleton></Skeleton>
      ) : isError ? (
        <Placeholder type="error">
          <Reload></Reload>
        </Placeholder>
      ) : orderList?.length > 0 ? (
        <div className={styles.contentWrap}>
          <OrderType></OrderType>
          {orderList.map((item) => {
            return (
              <OrderItem
                key={item.id}
                orderInfo={item}
                onRefresh={handleRefresh}
              ></OrderItem>
            )
          })}
          <div className={styles.paginationWrap}>
            {total > PAGE_SIZE && (
              <Pagination
                current={pageIndexRef.current}
                total={total}
                pageSize={PAGE_SIZE}
                onChange={handleChangePage}
                showSizeChanger={false}
                size="default"
              />
            )}
          </div>
        </div>
      ) : (
        <div className={styles.emptyWithOrderType}>
          <OrderType></OrderType>
          <Placeholder type="empty" title="暂无服务单"></Placeholder>
        </div>
      )}
    </div>
  )
}
